import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";

interface IServerResponse {
  status: string | boolean;
  message?: string;
  result?: any;
  count?: number;
  page?: number;
  totalPages?: number;
}

const API_URL = environment.API_URL + "/admin";

@Injectable()
export class GiftMoneyService {
  constructor(private https: Http) {}

  getSettings(): Observable<IServerResponse> {
    return this.https
      .get(API_URL + "/giftmoney/settings")
      .pipe(map((res) => res.json()));
  }

  updateSettings(payload: FormData | any): Observable<IServerResponse> {
    return this.https
      .put(API_URL + "/giftmoney/settings", payload)
      .pipe(map((res) => res.json()));
  }

  topupAdminWallet(amount: number, reason: string): Observable<IServerResponse> {
    return this.https
      .post(API_URL + "/giftmoney/topup", { amount, reason })
      .pipe(map((res) => res.json()));
  }

  getHistory(
    page: number = 1,
    limit: number = 20,
    type: string = "",
    startDate: string = "",
    endDate: string = "",
    search: string = ""
  ): Observable<IServerResponse> {
    const params = [
      "page=" + page,
      "limit=" + limit,
      type ? "type=" + encodeURIComponent(type) : "",
      startDate ? "start_date=" + encodeURIComponent(startDate) : "",
      endDate ? "end_date=" + encodeURIComponent(endDate) : "",
      search ? "search=" + encodeURIComponent(search) : "",
    ]
      .filter(Boolean)
      .join("&");

    return this.https
      .get(API_URL + "/giftmoney/history?" + params)
      .pipe(map((res) => res.json()));
  }

  setUserGiftMoneyDenied(userId: string, denied: boolean): Observable<IServerResponse> {
    return this.https
      .put(API_URL + "/giftmoney/deny/" + userId, { denied })
      .pipe(map((res) => res.json()));
  }
}
